import React, { useEffect, useRef, useState } from 'react';
import styles from './NewForm.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import ReactDOM from 'react-dom';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { fields } from './factory/fieldData';

const AddFormButton = ({
  activeDropdown,
  setActiveDropdown,
  containerRef,
  handleClick,
  addNewField,
}) => {
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  const [dropdownStyle, setDropdownStyle] = useState({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(false);
      }
    };
    if (activeDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeDropdown]);

  useEffect(() => {
    if (activeDropdown && containerRef.current && dropdownRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const dropdownWidth = 200;
      const dropdownHeight = dropdownRef.current.offsetHeight || 200;

      let calculatedTop =
        containerRect.bottom - dropdownHeight - 12 + window.scrollY;

      if (calculatedTop < 0) {
        calculatedTop = containerRect.top + window.scrollY + 12;
      }

      setDropdownStyle({
        position: 'absolute',
        top: `${calculatedTop}px`,
        left: `${
          containerRect.left +
          containerRect.width / 2 -
          dropdownWidth / 2 +
          window.scrollX
        }px`,
        width: `${dropdownWidth}px`,
        zIndex: 1000,
      });
    }
  }, [activeDropdown]);
  return (
    <div
      className={styles['line-container']}
      style={{ backgroundColor: page_ButtonColor }}
      ref={buttonRef}
    >
      <SvgWithBranding
        type="plusFilledSVG"
        color={page_ButtonColor}
        className={styles['add-button']}
        onClick={handleClick}
      />
      {activeDropdown &&
        ReactDOM.createPortal(
          <div
            className={`${styles['dropdown']} ${styles.opened}`}
            style={dropdownStyle}
            ref={dropdownRef}
          >
            <p>Add Fields</p>
            <ul>
              {fields.map((child, i) => (
                <li
                  key={i}
                  className={
                    child.isBordered
                      ? styles['bordered']
                      : styles['none-bordered']
                  }
                  onClick={() => addNewField(child.fieldType, child.fields)}
                >
                  <SvgWithBranding
                    type={child.icon}
                    className={styles.icon}
                    color={page_ButtonColor}
                  />
                  <p>{child.text}</p>
                </li>
              ))}
            </ul>
          </div>,
          document.getElementById('portal-root')
        )}
    </div>
  );
};

export default AddFormButton;
